import { createRouter, createWebHistory } from 'vue-router';
import store from '@/store';
import { cloneDeep } from 'lodash';
import { savePosition } from '@/common/utils/Supplimentary';

const updateRouteLayout = async meta => {
  const clone = cloneDeep(meta);
  await store.dispatch('layout/updateRouteLayout', {
    isHeader: clone.isHeader,
    titleName: clone.titleName,
    isBack: clone.isBack,
    isMenu: clone.isMenu,
    isLogo: clone.isLogo
  });
};

const routes = [
  {
    path: '/',
    component: () => import('@/views/root.vue')
  },
  {
    name: 'Login',
    path: '/login',
    component: () => import('@/views/login/index.vue'),
    meta: {
      isHeader: false,
      isMenu: false,
      isBack: false,
      titleName: ''
    }
  },
  {
    name: 'Join',
    path: '/join',
    component: () => import('@/views/join/index.vue'),
    meta: {
      isHeader: true,
      isMenu: false,
      isBack: true,
      titleName: '회원가입'
    }
  },
  {
    name: 'JoinComplete',
    path: '/join/complete',
    component: () => import('@/views/join/complete/index.vue'),
    meta: {
      isHeader: false,
      isMenu: false,
      isBack: false,
      titleName: ''
    }
  },
  {
    name: 'Home',
    path: '/main',
    component: () => import('@/views/main/index.vue'),
    meta: {
      titleName: '',
      isHeader: true,
      isMenu: true,
      isLogo: true,
      isBack: false
    }
  },
  {
    path: '/class/list',
    name: 'ClassList',
    component: () => import('@/views/class/list.vue'),
    meta: {
      isHeader: true,
      isMenu: false,
      isBack: true,
      isLogo: false,
      titleName: '수업리스트'
    }
  },
  {
    path: '/class/classDetail/:studentNo/:classNo',
    name: 'ClassDetail',
    component: () => import('@/views/class/classDetail.vue'),
    props: true, // params를 props로도 받도록 설정
    meta: {
      isHeader: true,
      isMenu: false,
      isBack: true,
      isLogo: false,
      titleName: '수업 상세정보'
    }
  },
  {
    path: '/class/orderDetail/:studentOrderNo/:orderIndex',
    name: 'OrderDetail',
    component: () => import('@/views/class/orderDetail.vue'),
    props: true, // params를 props로도 받도록 설정
    meta: {
      isHeader: true,
      isMenu: false,
      isBack: true,
      isLogo: false,
      titleName: '수업 상세정보'
    }
  },
  {
    path: '/class/orderDetail/:studentOrderNo/:orderIndex/:classContent(.*)/:className',
    redirect: to => ({
      name: 'OrderDetail',
      params: {
        studentOrderNo: to.params.studentOrderNo,
        orderIndex: to.params.orderIndex
      }
    })
  },
  {
    path: '/payment/list',
    name: 'PaymentList',
    component: () => import('@/views/payment/list.vue'),
    meta: {
      isHeader: true,
      isMenu: false,
      isBack: true,
      isLogo: false,
      titleName: '수강료 납부내역'
    }
  },
  {
    path: '/payment/detail/:studentOrderNo',
    name: 'PaymentDetail',
    component: () => import('@/views/payment/detail.vue'),
    props: true,
    meta: {
      isHeader: true,
      isMenu: false,
      isBack: true,
      isLogo: false,
      titleName: '수강료 납부내역'
    }
  },
  {
    path: '/user/edit',
    name: 'UserEdit',
    component: () => import('@/views/user/edit.vue'),
    meta: {
      isHeader: true,
      isMenu: false,
      isBack: true,
      isLogo: false,
      titleName: '개인정보 수정'
    }
  },
  {
    name: 'Notice',
    path: '/notice/list',
    component: () => import('@/views/notice/list.vue'),
    meta: {
      isHeader: true,
      isMenu: false,
      isBack: true,
      isLogo: false,
      titleName: '공지사항'
    }
  },
  {
    name: 'NoticeDetail',
    path: '/notice/detail/:boardNo',
    component: () => import('@/views/notice/detail.vue'),
    props: true,
    meta: {
      isHeader: true,
      isMenu: false,
      isBack: true,
      isLogo: false,
      titleName: '공지사항'
    }
  },
  {
    name: 'Alarm',
    path: '/alarm/list',
    component: () => import('@/views/alarm/list.vue'),
    meta: {
      isHeader: true,
      isMenu: false,
      isBack: true,
      isLogo: false,
      titleName: '알립니다'
    }
  },
  {
    name: 'AlarmDetail',
    path: '/alarm/detail/:alarmNo',
    component: () => import('@/views/alarm/detail.vue'),
    props: true,
    meta: {
      isHeader: true,
      isMenu: false,
      isBack: true,
      isLogo: false,
      titleName: '알립니다'
    }
  },
  {
    name: 'FAQ',
    path: '/faq',
    component: () => import('@/views/faq/index.vue'),
    meta: {
      isHeader: true,
      isMenu: false,
      isBack: true,
      isLogo: false,
      titleName: 'FAQ'
    }
  },
  {
    name: 'Push',
    path: '/push',
    component: () => import('@/views/push/index.vue'),
    meta: {
      isHeader: true,
      isMenu: false,
      isBack: true,
      isLogo: false,
      titleName: '알림 설정'
    }
  },
  {
    name: 'UserFind',
    path: '/user/find',
    component: () => import('@/views/user/find/index.vue'),
    meta: {
      isHeader: true,
      isMenu: false,
      isBack: true,
      isLogo: false,
      titleName: '계정 찾기'
    }
  },
  {
    name: 'UserFindPassword',
    path: '/user/find/password',
    component: () => import('@/views/user/find/password/index.vue'),
    meta: {
      isHeader: true,
      isMenu: false,
      isBack: true,
      isLogo: false,
      titleName: '비밀번호 변경'
    }
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  mode: 'history',
  routes
  // scrollBehavior(to, from, savedPosition) {
  //   // return { left: 0, top: 0 };
  //   if (store.getters['scroll/getPosition'].top > 0) {
  //     savePosition({ left: 0, top: store.getters['scroll/getPosition'].top });
  //   }
  //   return new Promise(resolve => {
  //     setTimeout(() => {
  //       if (savedPosition) {
  //         console.log(savePosition);
  //         resolve(savedPosition);
  //       } else {
  //         resolve({ left: 0, top: 0 });
  //       }
  //     }, 500);
  //   });
  // }
});

window.routeQuery = '';
window.path = '';

/**
 * router를 타기전에 실행되는 메서드
 * updateRouteLayout에서 meta - Logo, Nav 등을 commit하여 적용
 */
router.beforeEach(async (to, from, next) => {
  const accessToken = store.getters['user/getAccessToken'];

  let meta = to.meta;
  // nativeCall.fnBack() 에서 안드로이드 메인-뒤로가기 시 종료를 위한 isRoot값 세팅
  if (to.path === '/main' || to.path === '/login') to.query = { isRoot: 1 };
  // 회원가입일땐 예외
  if ((!accessToken && to.path.includes('/join')) || (!accessToken && to.path.includes('/user/find'))) {
    next();
  }

  await updateRouteLayout(meta);
  window.routeQuery = to.query;
  window.path = to.path;

  next();
});

export default router;
